import { useEffect, useState } from "react";
import { IoMdCloseCircle } from "react-icons/io";
import { getCompanyLogins } from "../../services/clientLogins.service";
import styles from "./css/clientLoginsModal.module.css";

export default function ClientLoginsModal({ show, companyId, onClose, formatDateTime }) {
  const [logins, setLogins] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(null);

  useEffect(() => {
    const handleGetLogins = async () => {
      try {
        if (!show || !companyId) return;

        setLoading(true);
        setError(null);

        const loginsData = await getCompanyLogins({ companyId });
        setLogins(loginsData);

      } catch (err) {
        console.error("ERROR - GET COMPANY LOGINS FUNCTION:", err);
        setLogins([]);
        setError("Nao foi possivel carregar os logins no momento.");

      } finally {
        setLoading(false);
      }
    };

    handleGetLogins();
  }, [show, companyId]);

  if (!show) return null;

  return (
    <div className={styles.modalOverlay} onClick={onClose}>
      <div className={styles.modalContainer} onClick={(event) => event.stopPropagation()}>
        <header className={styles.modalHeader}>
          <h2 className={styles.modalTitle}>Logins da empresa</h2>

          <button type="button" className={styles.closeButton} onClick={onClose}>
            <IoMdCloseCircle size={24} color="#2f3e49" />
          </button>
        </header>

        <div className={styles.modalBody}>
          {loading ? (
            <p>Carregando logins...</p>

          ) : error ? (
            <p>{error}</p>

          ) : logins.length === 0 ? (
            <p>Nenhum login encontrado para esta empresa.</p>

          ) : (
            <div className={styles.listArea}>
              {logins.map((item) => (
                <article key={item.id} className={styles.listItem}>
                  <p><b>Nome:</b> {item.name}</p>
                  <p><b>Email:</b> {item.email}</p>
                  <p><b>Data do login:</b> {formatDateTime(item.loggedAt)}</p>
                </article>
              ))}
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
